module.exports = __webpack_public_path__ + "media/images/gallery/constellations/libra/lib_vis-f7577ac47c58aba8ec58d2b6cf024b64.jpg";